import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';
import { useAppStore } from '@/stores/appStore';
import { Header } from '@/components/Header';
import { Sidebar } from '@/components/Sidebar';
import { MobileSidebar } from '@/components/MobileSidebar';
import { useBreakpoint } from '@/hooks/useMediaQuery';
import { useTouchGestures } from '@/hooks/useTouchGestures';
import { useClerkAuth } from '@/hooks/useClerkAuth';
import { cn } from '@/lib/utils';

export function Layout() {
  const { ui, setUser, setMobile, toggleSidebar } = useAppStore();
  const { isMobile, isTablet } = useBreakpoint();
  const { user: clerkUser, isLoaded } = useUser();

  // Initialize Clerk authentication integration
  useClerkAuth();

  // Set user data from Clerk
  useEffect(() => {
    if (isLoaded && clerkUser) {
      setUser({
        id: clerkUser.id,
        name: clerkUser.fullName || clerkUser.firstName || clerkUser.emailAddresses[0]?.emailAddress || 'User',
        authenticated: true,
      });
    }
  }, [clerkUser, isLoaded, setUser]);

  // Update mobile state
  useEffect(() => {
    setMobile(isMobile);
  }, [isMobile, setMobile]);

  // Touch gestures for mobile navigation
  const touchRef = useTouchGestures({
    onSwipeRight: () => {
      if (isMobile && !ui.sidebarOpen) {
        toggleSidebar();
      }
    },
    onSwipeLeft: () => {
      if (isMobile && ui.sidebarOpen) {
        toggleSidebar();
      }
    },
    threshold: 100,
  });

  return (
    <div ref={touchRef} className="flex h-screen overflow-hidden">
      {/* Desktop/Tablet Sidebar */}
      {!ui.mobile && (
        <div
          className={cn(
            'transition-all duration-300 ease-in-out border-r border-border',
            ui.sidebarOpen ? (isTablet ? 'w-64' : 'w-80') : 'w-0'
          )}
        >
          <Sidebar />
        </div>
      )}

      {/* Mobile Sidebar */}
      <MobileSidebar />

      {/* Main content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}